<span (click)="onClearFilters()" matTooltip="Clear all filters" matTooltipClass="text-center" matTooltipPosition="above" class="cancel-filter">
  <i class="fal fa-minus-circle"></i>
</span>
